const asyncActions: any = {
  LOGIN_USER: 'LOGIN_USER',
  ADD_USER: 'ADD_USER',
  LOGOUT_USER: 'LOGOUT_USER',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
};

const syncActions: any = {
  ADD_TO_CART: 'ADD_TO_CART',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
  ADD_QUANTITY: 'ADD_QUANTITY',
  SUBTRACT_QUANTITY: 'SUBTRACT_QUANTITY',
  SET_PRICE_RANGE: 'SET_PRICE_RANGE',
  SET_RATING: 'SET_RATING',
  SET_SORT_FILTER: 'SET_SORT_FILTER',
  RESET_SORT_FILTER: 'RESET_SORT_FILTER',
  ADD_COUPONCODE: 'ADD_COUPONCODE',
  RESET_COUPONCODE: 'RESET_COUPONCODE',
  ADD_TO_WISHLIST: 'ADD_TO_WISHLIST',
  REMOVE_FROM_WISHLIST: 'REMOVE_FROM_WISHLIST',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  SET_TOAST: 'SET_TOAST',
  CLOSE_TOAST: 'CLOSE_TOAST',
};

const actionTypes = {
  ...asyncActions,
  ...syncActions,
};

export default actionTypes;
